"use strict";
var $dyn;
(function ($dyn) {
    var ui;
    (function (ui) {
        function _addPropertiesToPrototypeInternal(proto, properties) {
            if (proto && properties) {
                var _loop_1 = function (name_1) {
                    (function () {
                        var propName = name_1;
                        var createGetter;
                        var createSetter;
                        var prop = properties[propName];
                        if (typeof prop !== "object") {
                            prop = properties[propName] = {
                                attribute: prop,
                                defaultValue: prop,
                            };
                        }
                        prop.name = name_1;
                        // DOM attributes should be lower case
                        prop.attribute = prop.attribute || propName.toLowerCase();
                        var converter = prop.converter || $dyn.util.converters[typeof prop.defaultValue] || $dyn.util.converters.string;
                        prop.serialize = prop.serialize === undefined ? false : prop.serialize;
                        prop.invokeHandlers = prop.invokeHandlers === undefined ? true : prop.invokeHandlers;
                        var attributeSetter;
                        if (prop.serialize) {
                            if (prop.attributeSetter) {
                                attributeSetter = prop.attributeSetter;
                            }
                            else if (typeof prop.defaultValue === "boolean") {
                                attributeSetter = $dyn.ui.booleanAttributeSetter(prop.attribute);
                            }
                            else {
                                attributeSetter = $dyn.ui.setAttribute;
                            }
                        }
                        prop.backingField = prop.backingField || "_" + propName;
                        if (prop.observable) {
                            createGetter = $dyn.ui._observableGetter;
                            createSetter = $dyn.ui._observableSetter;
                        }
                        else {
                            createGetter = $dyn.ui._propertyGetter;
                            createSetter = $dyn.ui._propertySetter;
                        }
                        proto[prop.backingField] = prop.defaultValue;
                        Object.defineProperty(proto, propName, {
                            get: createGetter(prop.backingField),
                            set: createSetter(prop.backingField, propName, prop.attribute, converter, attributeSetter, prop.defer, prop.defaultValue, prop.invokeHandlers),
                        });
                    })();
                };
                // tslint:disable-next-line:forin
                for (var name_1 in properties) {
                    _loop_1(name_1);
                }
            }
        }
        /**
         * Creates a control prototype using prototypical inheritance.
         * Supports ObservableProperties property which is a dictionary of property name/default value pairs.
         *
         * The $dyn.ui.Control constructor must be called to handle the actual creation of the observable properties.
         * Even though controls are not required to have observable properties, controls are recommended to use $dyn.ui.extendPrototype instead of $dyn.extendPrototype.
         *
         * @see $dyn.extendPrototype. Adds support for easy adding of properties that must be observable for the control to function correctly.
         * @param basePrototype The base prototype object whose properties will be extended by the child.
         * @param childPrototype The child prototype.
         * @returns The new prototype.
         */
        function extendPrototype(basePrototype, childPrototype) {
            if (childPrototype.ObservableProperties) {
                // This is a control specific behavior.
                $dyn.ui._initObservableProperties(childPrototype, basePrototype);
            }
            var proto = $dyn.extendPrototype(basePrototype, childPrototype);
            var properties = childPrototype.properties;
            if (properties) {
                /*
                 * @example
                 * $dyn.controls.TestSimpleControl = function () {
                 *    $dyn.ui.Control.apply(this, arguments);
                 * };
                 *
                 * $dyn.controls.TestSimpleControl.prototype = $dyn.ui.extend($dyn.ui.Control.prototype, {
                 *  properties: {
                 *      myProperty: {
                 *          defaultValue: $dyn.controls.TestSimpleControl.sampleEnum.A,
                 *          options: $dyn.controls.TestSimpleControl.sampleEnum,
                 *
                 *          // Determines if the property has an attribute associated to it.
                 *          serialize: false,
                 *
                 *          // The name of the attribute to set.
                 *          attribute: '',
                 *
                 *          // Converts the attribute from property value to the attribute.
                 *          // The default attribute
                 *          // function (element, attributeName, newValue, oldValue)
                 *          attributeSetter: $dyn.ui.setAttribute,
                 *
                 *          // Observable properties can be observed in computations and therefore bindings.
                 *          // Observable properties has the same public api as non-observable properties.
                 *          observable: false,
                 *
                 *          // A property can have a backing field where the value (or observable when observable: true).
                 *          // The default backing field is underscore followed by the property name.
                 *          backField: '_myProperty',
                 *
                 *          // The converter ensures that the value is converted to specific type.
                 *          // For example a boolean converter will ensure that the property is a boolean.
                 *          // This allows for properties that conform to the dom elements properties.
                 *          // The converter is inferred from the default value.
                 *          // The string converter ensures the value is a string (not null, undefined, or object).
                 *          // The boolean converter ensures the value is a boolean (converted from 'truthy' value).
                 *          // The number converter ensures the value is a number (or default value when can't convert).
                 *          converter: $dyn.util.converters.string,
                 *
                 *          // Defers the change events until the end of the current "task"
                 *          defer: false,
                 *
                 *          // Set invoke handlers to true if the property is used in a binding handler.
                 *          invokeHandlers: true
                 *        } // end myProperty
                 *  }, // end properties
                 *
                 *  // A change method can be a function with an underscore then the name of the property + 'Changed' put
                 *  //  on the prototype
                 *  // The change method is private (indicated by underscore).
                 *  // The changed method for a property should not be called initially.
                 *  _myPropertyChanged: function () {
                 *  },
                 * } // end control
                 */
                _addPropertiesToPrototypeInternal(proto, properties);
                if (basePrototype.properties && proto.properties) {
                    proto.properties = $dyn.extendPrototype(basePrototype.properties, proto.properties);
                }
            }
            return proto;
        }
        ui.extendPrototype = extendPrototype;
        ui.extend = $dyn.ui.extendPrototype;
        /**
         * Adds the provided set of properties to the provided control class prototype
         * @param proto The prototype to add properties to
         * @param propertiesToAdd The mapping of control properties to add
         */
        function addPropertiesToPrototype(proto, propertiesToAdd) {
            if (propertiesToAdd) {
                _addPropertiesToPrototypeInternal(proto, propertiesToAdd);
                if (proto.properties) {
                    proto.properties = $dyn.extendPrototype(proto.properties, propertiesToAdd);
                }
                else {
                    proto.properties = propertiesToAdd;
                }
            }
        }
        ui.addPropertiesToPrototype = addPropertiesToPrototype;
        /**
         * Adds the provided set of observable properties to the provided control class prototype
         * @param proto The prototype to add properties to
         * @param propertiesToAdd The mapping of observable control properties to add
         */
        function addObservablePropertiesToPrototype(proto, propertiesToAdd) {
            // The childPrototype.ObservableProperties is not currently used during construction of an instance of a control.  There are only used to help build control prototypes.
            Object.defineProperties(proto, $dyn.getOwnPropertyDescriptors(propertiesToAdd));
            if (proto && proto.ObservableProperties) {
                // Properties are inherited from the base control.
                propertiesToAdd = Object.create(proto.ObservableProperties, $dyn.getOwnPropertyDescriptors(propertiesToAdd));
            }
            // The list of properties being added will have been extended in the previous if condition, save them on the prototype now
            if (propertiesToAdd) {
                proto.ObservableProperties = propertiesToAdd;
            }
            if (proto.ObservableProperties) {
                proto._observablePropertyList = [];
                // Keep a cached list of properties as an array on the prototype for faster property iteration.
                // tslint:disable-next-line:forin
                for (var propertyName in proto.ObservableProperties) {
                    proto._observablePropertyList.push(propertyName);
                }
            }
        }
        ui.addObservablePropertiesToPrototype = addObservablePropertiesToPrototype;
        /**
         * Function generator that when called will return the backing field's value.
         * @internal Used by $dyn.ui.extendPrototype.
         */
        function _observableGetter(backingField) {
            return function observableGetter() {
                var value = this[backingField];
                if (value === undefined || value === null || !value.valueChanged) {
                    // value is not an observable
                    value = this[backingField] = $dyn.observable(value);
                }
                return value();
            };
        }
        ui._observableGetter = _observableGetter;
        /**
         * Function generator that when called will set the backing field's value.
         * @internal Used by $dyn.ui.extendPrototype.
         */
        function _observableSetter(backingField, propertyName, attribute, converter, attributeSetter, defer, defaultValue, invokeHandlers) {
            var propChangedName = propertyName + "Changed";
            return function observableSetter(newValue) {
                this.updatingBlock.call(this, function () {
                    var _this = this;
                    var self = this;
                    var oldValue = this[propertyName];
                    /// #DEBUG
                    if ($dyn.isObservable(newValue)) {
                        throw new TypeError("Cannot set a control property to an observable object.");
                    }
                    /// #ENDDEBUG
                    if (oldValue !== newValue) {
                        this[backingField](converter(newValue, oldValue, defaultValue));
                        var onChanged_1 = this[propChangedName];
                        if (!defer) {
                            onChanged_1 && onChanged_1.call(this, newValue, oldValue);
                            attributeSetter && attributeSetter.call(self, self.element, newValue, oldValue, attribute);
                        }
                        else {
                            $dyn.microTask(function () {
                                onChanged_1 && onChanged_1.call(_this, newValue, oldValue);
                                attributeSetter && attributeSetter.call(self, self.element, newValue, oldValue, attribute);
                            });
                        }
                    }
                });
            };
        }
        ui._observableSetter = _observableSetter;
        /**
         * Function generator that when called will return the backing field's value.
         * @internal Used by $dyn.ui.extendPrototype.
         */
        function _propertyGetter(backingField) {
            return function propertyGetter() {
                return this[backingField];
            };
        }
        ui._propertyGetter = _propertyGetter;
        /**
         * Function generator that when called will set the backing field's value.
         * @internal Used by $dyn.ui.extendPrototype.
         */
        function _propertySetter(backingField, propertyName, attribute, converter, attributeSetter, defer, defaultValue, invokeHandlers) {
            var propChangedName = propertyName + "Changed";
            return function propertySetter(newValue) {
                this.updatingBlock.call(this, function () {
                    var self = this;
                    /// #DEBUG
                    if ($dyn.isObservable(newValue)) {
                        throw new TypeError("Cannot set a control property to an observable object.");
                    }
                    /// #ENDDEBUG
                    var oldValue = this[propertyName];
                    var convertedValue = converter(newValue, oldValue, defaultValue);
                    if (oldValue !== convertedValue) {
                        this[backingField] = convertedValue;
                        var onChanged_2 = this[propChangedName];
                        if (!defer) {
                            onChanged_2 && onChanged_2.call(this, newValue, oldValue);
                            attributeSetter && attributeSetter.call(self, self.element, newValue, oldValue, attribute);
                        }
                        else {
                            $dyn.microTask(function () {
                                onChanged_2 && onChanged_2.call(self, newValue, oldValue);
                                attributeSetter && attributeSetter.call(self, self.element, newValue, oldValue, attribute);
                            });
                        }
                    }
                });
            };
        }
        ui._propertySetter = _propertySetter;
        /**
         * Gets an observable for a property that uses an observable as the storage for the value.
         */
        function getObservableProperty(control, propertyName) {
            if (control && propertyName) {
                var propertyValue = control[propertyName];
                if ($dyn.isObservable(propertyValue)) {
                    return propertyValue;
                }
                var propertyMetadata = control.properties && control.properties[propertyName];
                if (propertyMetadata && propertyMetadata.observable) {
                    return control[propertyMetadata.backingField];
                }
                return propertyValue;
            }
        }
        ui.getObservableProperty = getObservableProperty;
        /**
         * @private
         */
        function _initObservableProperties(childPrototype, basePrototype) {
            // The childPrototype.ObservableProperties is not currently used during construction of an instance of a control.  There are only used to help build control prototypes.
            Object.defineProperties(childPrototype, $dyn.getOwnPropertyDescriptors(childPrototype.ObservableProperties));
            if (basePrototype && basePrototype.ObservableProperties) {
                // Properties are inherited from the base control.
                childPrototype.ObservableProperties = Object.create(basePrototype.ObservableProperties, $dyn.getOwnPropertyDescriptors(childPrototype.ObservableProperties));
            }
            if (childPrototype.ObservableProperties) {
                childPrototype._observablePropertyList = [];
                // Keep a cached list of properties as an array on the prototype for faster property iteration.
                // tslint:disable-next-line:forin
                for (var propertyName in childPrototype.ObservableProperties) {
                    childPrototype._observablePropertyList.push(propertyName);
                }
            }
        }
        ui._initObservableProperties = _initObservableProperties;
        /**
         * Apply the default values to the control and the data object
         * @internal
         */
        function applyDefaults(control, options, defaults) {
            if (!options) {
                options = {};
            }
            // tslint:disable-next-line:forin
            for (var property in defaults) {
                var value_1 = options[property];
                var currentControl = control;
                if (property in control) {
                    if ($dyn.isObservable(currentControl[property])) {
                        value_1 = $dyn.value(value_1);
                        currentControl[property](value_1 !== undefined ? value_1 : defaults[property]);
                        options[property] = currentControl[property];
                    }
                    else {
                        if (control.properties && control.properties[property]) {
                            options[property] = currentControl[property] = $dyn.value(value_1) !== undefined ? $dyn.value(value_1) : defaults[property];
                        }
                        else {
                            options[property] = currentControl[property] = $dyn.observable($dyn.value(value_1) !== undefined ? $dyn.value(value_1) : defaults[property]);
                        }
                    }
                }
                else {
                    if ($dyn.isObservable(value_1)) {
                        currentControl[property] = value_1;
                    }
                    else {
                        options[property] = currentControl[property] = $dyn.observable($dyn.value(value_1) !== undefined ? $dyn.value(value_1) : defaults[property]);
                    }
                }
            }
        }
        ui.applyDefaults = applyDefaults;
        /**
         * Returns a computed that will return the specified autoValue instead of 'Auto'.
         * @param autoValue The value $dyn.ui.autoValue should resolve to
         * @param control The control containing the property to resolve
         * @param backingProperty The name of the property
         */
        function autoProperty(autoValue, control, backingProperty) {
            return $dyn.computed(function () {
                var propertyValue = $dyn.value(control[backingProperty]);
                if (propertyValue === $dyn.ui.autoValue) {
                    propertyValue = autoValue;
                }
                return propertyValue;
            }, function (value) {
                $dyn.setValue(control, backingProperty, value);
            });
        }
        ui.autoProperty = autoProperty;
    })(ui = $dyn.ui || ($dyn.ui = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ControlBuilder.js.map
